import { ReactNode } from 'react'

import { Box, useDisclosure } from '@chakra-ui/react'
import { IoInformationCircleOutline } from 'react-icons/io5'

import {
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/ui/popover'

type InformationIconProps = {
  info: ReactNode
  contentWidth?: string
  whiteSpace?: 'pre-line' | 'normal'
  children?: ReactNode
}

const InformationIcon = ({
  info,
  contentWidth,
  whiteSpace = 'normal',
  children = <IoInformationCircleOutline color="#60a5fa" size={20} />,
}: InformationIconProps) => {
  const { open, onOpen, onClose } = useDisclosure()
  return (
    <PopoverRoot
      autoFocus={false}
      open={open}
      size="sm"
      onOpenChange={(e) => {
        if (!e.open) {
          onClose()
        }
      }}
    >
      <PopoverTrigger asChild>
        <Box
          _hover={{
            bg: 'gray.100',
            borderRadius: '5px',
          }}
          aria-label="info"
          onMouseEnter={onOpen}
          onMouseLeave={onClose}
        >
          {children}
        </Box>
      </PopoverTrigger>
      <PopoverContent width={contentWidth}>
        <PopoverArrow />
        <PopoverBody fontSize="small" whiteSpace={whiteSpace}>
          {info}
        </PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  )
}

export default InformationIcon
